import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b69a714"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Update Campfire", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please wait while the system sends the new tokens to the Campfire integration. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If further assistance is required, please raise an "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://infusion.fusion5.com.au/" }, "iHelp"),
  /*#__PURE__*/_createTextVNode(" ticket. ")
], -1))
const _hoisted_4 = { style: {"padding-bottom":"30px","padding-top":"15px"} }
const _hoisted_5 = {
  key: 0,
  class: "loadingBox"
}
const _hoisted_6 = { class: "loadingBoxInner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-top":"10px"} }, "Updating Campfire...", -1))
const _hoisted_8 = {
  key: 1,
  class: "finishedBox"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "finishedBoxInner" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"80px"} }, "✓"),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-top":"10px"} }, "Update Successful")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "errorBox"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "errorBoxInner" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"80px"} }, "✕"),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-top":"10px"} }, "Update Failed")
], -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_van_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, null, {
            default: _withCtx(() => [
              (_ctx.status === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_van_loading, { size: 100 }),
                      _hoisted_7
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.status === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}